// THE POP-UP FORM SPACING STANDARD (owner, 2026-10-09 — D-346: "It feels a bit
// cramped. If we have standards for spacing and/or padding, I am not sure that
// they are being followed. If we do not, maybe we should ... I do not want to
// break everything else on the site, particularly the invoice modal.").
//
// There was none: pop-up forms spaced their fields 10, 12 or 16px apart. This is
// the one rule for a form inside a pop-up — 16px between fields, down and
// across, and 24px between the last field and the buttons — on Fluent's own
// spacing tokens. Any pop-up form built or reworked from now on uses it.
//
// WHERE IT APPLIES (owner, 2026-10-12 — D-349: "verify the new spacing rule
// across all modals"). Every pop-up whose body is fields or a confirmation:
// the Filters dialog; the Assignments pop-ups; every References and Rules
// Add/Edit pop-up, Rules → Routing's included (its sentence keeps its own
// spacing, the buttons sit 24px below it); every "Are you sure?"
// (`DecisionDialog`, `ConfirmDialog`, `MakeInactiveDialog`, the vendor
// import's second press); the Import pop-up's first page; and the Override
// pop-up (D-350), which replaced the invoice modal's routing Details. The
// invoice modal itself is a page in a pop-up, not
// a form: its summary grid takes `grid2` (16px down and across, D-349), and
// the rest keeps its own layout, already 16px between sections. Measured in
// the browser, nothing in it looked broken, so it is not an exception.
//
// THE EXCEPTIONS, not a set of fields above a row of buttons: Pipeline (a
// picture), Upload and Custom Notifications (screens in a pop-up, with no button
// row), a notification's email (Notifications), Compare Invoices (a full-screen view), and
// the Import preview (a report, which keeps its 12px rhythm).
// `mock/tests/popup-form-spacing.test.ts` holds both lists.
//
// A plain hook, not a component: `react-refresh/only-export-components` keeps
// shared style hooks out of component files (`popupPositioning.ts` likewise).
import { makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  /** One field under another. */
  stack: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalL },
  /** Two fields a row — a range's From beside its To. */
  grid2: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    columnGap: tokens.spacingHorizontalL,
    rowGap: tokens.spacingVerticalL,
    alignItems: 'end',
  },
  /** On `DialogContent`, so the buttons sit 24px below the last field.
      Fluent's `DialogBody` puts 8px between content and actions, and
      `DialogContent` carries 2px of padding inside a -2px margin (room for a
      focus outline), so 16px replacing that padding measured 22px (D-349).
      Keeping the 2px and adding 16px measures 24px. */
  beforeActions: { paddingBottom: `calc(${tokens.spacingVerticalXXS} + ${tokens.spacingVerticalL})` },
  /* THE APPROVAL-STEP PICTURE AND ITS LEAD LINE ("require the following
     approvals:"), spaced alike in the two pop-ups that draw it (owner,
     2026-10-12 — D-350 amended: "more spacing above and below 'Instead,
     require the following approvals:'", matching the Add/Edit Rule pop-up).
     Measured from the Add/Edit Rule pop-up, which had it first: the line 12px
     below what is above it, the picture 8px below the line, both inside a
     column 4px apart (that pop-up's condition stack) — 16px above the line and
     12px from the line to the picture. The group then keeps 24px below it. */
  /** The column the line and the picture sit in, where no 4px column holds them already. */
  routeGroup: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXS, marginBottom: tokens.spacingVerticalS },
  /** The lead line. */
  routeLead: { marginTop: tokens.spacingVerticalM },
  /** The picture: capped, so its connectors read as the Pipeline's short links. */
  routeDiagram: { marginTop: tokens.spacingVerticalS, overflowX: 'auto', maxWidth: '520px' },
})

export function useDialogFormStyles() {
  return useStyles()
}
